import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import MediaUpload from '../MediaUpload';
import { useMedia } from '@/contexts/MediaContext';
import { useAuth } from '@/contexts/AuthContext';
import { X } from 'lucide-react';

const Layout = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const { setSearchQuery, loadFiles } = useMedia();
  const { user } = useAuth();

  const handleUploadComplete = () => {
    setIsUploadOpen(false);
    if (user?.uid) {
      loadFiles(user.uid);
    }
  };

  return (
    <div className="flex h-screen bg-slate-950 overflow-hidden text-slate-100 selection:bg-cyan-500/30">
      {/* Sidebar fixa à esquerda */}
      <div className="w-64 flex-shrink-0 h-full border-r border-slate-800 bg-slate-900/50 backdrop-blur-xl shadow-2xl z-20 hidden md:block">
        <Sidebar />
      </div>

      {/* Área principal */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-slate-950">
        {/* Header no topo */}
        <header className="h-16 bg-slate-900/50 backdrop-blur-md border-b border-slate-800/50 shadow-sm z-10 sticky top-0">
          <Header 
            onUploadClick={() => setIsUploadOpen(true)} 
            onSearchChange={setSearchQuery}
          />
        </header>

        {/* Conteúdo rolável */}
        <main className="flex-1 overflow-y-auto p-6 scroll-smooth">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Modal de Upload */}
      {isUploadOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-slate-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-slate-700">
            <div className="flex justify-between items-center p-6 border-b border-slate-800">
              <h2 className="text-xl font-bold text-white">Upload de Mídia</h2>
              <button 
                onClick={() => setIsUploadOpen(false)}
                className="text-slate-400 hover:text-white transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>
            <div className="p-6">
              <MediaUpload onUploadComplete={handleUploadComplete} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;
